export default function ValidateAddress(Address) {
  var valid = true;

  var rfvAddress = Address.siblings("#AddressRequired");

  rfvAddress.hide();
  Address.removeClass("error");
  if ($.trim(Address.val()).length == 0) {
    valid = false;
    rfvAddress.show();
    Address.addClass("error");
  }
  return valid;
}